export default "__VITE_ASSET__DPMefh4Y__"